(function ($) {

    jQuery(document).ready(function ($) {

// ==============================================================
// 3d slider vue.js
// ==============================================================

        if ($('.slider-info').length > 0) {
            new Vue({
                el: '#slider_date',
                data: {
                    slides: 0
                },
                components: {
                    'carousel-3d': Carousel3d.Carousel3d,
                    'slide': Carousel3d.Slide
                },

                mounted: function () {
                    let self = this;
                    self.slides = slider_about_data.slider_data;
                }
            });
        }

    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/vue-slider.es6